import { createSelector } from '@ngrx/store';

import { wizzardState } from '../root';

export const getWizzardErrors = createSelector(wizzardState, (wizzard) => wizzard.errors);
